<template>
  <div class="employer-detail">
    <div class="basic-info">
      <div class="top">
        <div class="img-wrap">
          <img
            :src="info.enterpriseLogo | avatar('company')"
            v-img-error-company
          />
        </div>
        <div class="info">
          <h2 class="van-ellipsis">
            {{ info.shortName || info.enterpriseName }}
          </h2>
          <ul v-if="info.statistics">
            <li>
              <span class="label">面试率</span>
              <span class="text" v-if="info.statistics.interviewRate"
                >{{ info.statistics.interviewRate | toPercent(1) }}%</span
              >
              <span v-if="!info.statistics.interviewRate">-</span>
            </li>
            <li>
              <span class="label">成单率</span>
              <span class="text" v-if="info.statistics.offerRate"
                >{{ info.statistics.offerRate | toPercent(1) }}%</span
              >
              <span v-if="!info.statistics.offerRate">-</span>
            </li>
            <li>
              <span class="label">过保率</span>
              <span class="text" v-if="info.statistics.overGuaranteeRate"
                >{{ info.statistics.overGuaranteeRate | toPercent(1) }}%</span
              >
              <span v-if="!info.statistics.overGuaranteeRate">-</span>
            </li>
          </ul>
        </div>
      </div>
      <ul class="data" v-if="info.statistics">
        <li>
          <p>{{ info.statistics.recommendCount || "-" }}</p>
          <p class="desc">推荐候选人</p>
        </li>
        <li>
          <p>{{ info.statistics.interviewCount || "-" }}</p>
          <p class="desc">面试候选人</p>
        </li>
        <li>
          <p>{{ info.statistics.offerCount || "-" }}</p>
          <p class="desc">录用候选人</p>
        </li>
      </ul>
    </div>
    <van-tabs v-model="activeName" sticky>
      <van-tab title="公司概况" name="company">
        <!-- <employer-info :info="info" ></employer-info> -->
        <employer-survey :info="info"></employer-survey>
      </van-tab>
      <van-tab title="招聘职位" name="position">
        <van-list
          v-if="(list && list.length) || loading"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <position
            v-for="item in list"
            :position="item"
            type="companyDetail"
          ></position>
        </van-list>
        <no-data v-else></no-data>
      </van-tab>
    </van-tabs>
    <div class="care">
      <a @click="care">{{ info.isFollow ? "取消关注" : "关注" }}</a>
    </div>
  </div>
</template>

<script>
import EmployerInfo from "@/components/employer/employerInfo";
import EmployerSurvey from "@/components/employer/employerSurvey";
import Position from "@/components/position/position";
import { getDetail } from "@/api/employer";
import {
  getPositionList,
  getPositionTags,
  getPositionStatistics,
} from "@/api/positions";
import { follow, unFollow } from "@/api/employer";
import NoData from "@/components/noData";

export default {
  name: "employerDetail",
  data() {
    return {
      loading: false,
      finished: false,
      activeName: "company",
      list: [],
      info: {},
      pageNo: 1,
      pageSize: 10,
    };
  },
  components: {
    EmployerInfo,
    Position,
    NoData,
    EmployerSurvey,
  },
  methods: {
    care() {
      if (this.info.isFollow) {
        unFollow({ enterpriseId: this.info.enterpriseId })
          .then((res) => {
            this.info.isFollow = false;
            Toast.success("已取消");
          })
          .catch((err) => {});
      } else {
        follow({ enterpriseId: this.info.enterpriseId })
          .then((res) => {
            this.info.isFollow = true;
            Toast.success("已关注");
          })
          .catch((err) => {});
      }
    },
    onLoad() {
      this.loading = true;
      getPositionList({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        companyId: this.$route.params.id,
      })
        .then((res) => {
          let curIds = [];

          if (res.data && res.data.list) {
            curIds = res.data.list.map((item) => item.positionId) || [];

            res.data.list.forEach((item) => {
              item.positionTags = [];
              item.statics = {};
            });

            this.list = this.list.concat(res.data.list);

            this.pageNo++;
            if (res.data.list.length < this.pageSize) this.finished = true;
          } else {
            this.finished = true;
          }

          if (curIds && curIds.length) {
            this.positionTags(curIds);
            this.positionStatistics(curIds);
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    positionTags(curIds) {
      getPositionTags({ positionIds: curIds.join(",") })
        .then((res) => {
          this.list.forEach((item) => {
            if (res.data && res.data[item.positionId]) {
              item.positionTags = res.data[item.positionId];
            }
          });
        })
        .catch((err) => {});
    },
    positionStatistics(curIds) {
      getPositionStatistics({ positionIds: curIds.join(",") })
        .then((res) => {
          this.list.forEach((item) => {
            if (res.data && res.data[item.positionId]) {
              item.statics = res.data[item.positionId];
            }
          });
        })
        .catch((err) => {});
    },
    init() {
      getDetail({ id: this.$route.params.id })
        .then((res) => {
          if (res.data) {
            res.data.highlights = res.data.highlights
              ? res.data.highlights.split(",")
              : [];
            res.data.tags = res.data.tags ? res.data.tags.split(",") : [];
            res.data.addressDesc =
              (res.data.provinceName || "") +
              (res.data.cityName || "") +
              (res.data.address || "");
            this.info = res.data || {};
            this.$store.commit("comp/WX_SHARE", {
              title:
                "猎上雇主 - " +
                res.data.enterpriseName +
                " - " +
                res.data.cityName,
              desc: "重新定义人才服务",
            });
          }
        })
        .catch((err) => {});
      this.onLoad();
    },
  },
  created() {
    this.init();
  },
};
</script>

<style scoped lang="scss">
.employer-detail {
  padding-bottom: 65px;
  .basic-info {
    padding: 15px 15px 0 15px;
    background: #fff;
    margin-bottom: 10px;
    .top {
      padding-bottom: 15px;
      border-bottom: 0.5px solid #e5e5e5;
      display: flex;
      .img-content {
        margin-right: 15px;
        border-radius: 4px;
        border-radius: 4px;
        overflow: hidden;
      }
      .img-wrap {
        margin-right: 10px;
        border-radius: 4px;
        overflow: hidden;
        height: 60px;
        width: 60px;
        line-height: 60px;
        text-align: center;
        vertical-align: middle;
        background-color: #fafafa;
        flex-shrink: 0;
      }
      .info {
        width: 100%;
        h2 {
          font-size: 16px;
          color: #333333;
          line-height: 35px;
          max-width: 238px;
        }
        ul {
          font-size: 10px;
          color: #666666;
          line-height: 25px;
          display: flex;
          white-space: nowrap;
          /*justify-content: space-between;*/
          li {
            display: flex;
            margin-right: 5px;
            &:last-child {
              margin-right: 0;
            }
            span.label {
              color: #333333;
              margin-right: 5px;
            }
            span.text {
              color: #22baa5;
            }
          }
        }
      }
    }
    .data {
      display: flex;
      padding: 15px 0 15px 0;
      li {
        flex-grow: 1;
        p {
          font-size: 16px;
          color: #333333;
          text-align: center;
          line-height: 15px;
          margin-bottom: 10px;
          &.desc {
            font-size: 12px;
            color: #666666;
            margin-bottom: 0;
          }
        }
      }
    }
  }
  .care {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 10px 15px;
    background-color: #fafafa;
    z-index: 99;
    a {
      border: 0.5px solid #37c1bc;
      border-radius: 4px;
      width: 100%;
      height: 45px;
      line-height: 45px;
      font-size: 16px;
      color: #22baa5;
      display: inline-block;
      text-align: center;
      background-color: #fff;
    }
  }
}
</style>

<style lang="scss">
.employer-detail {
  .basic-info .top .van-image {
    margin-right: 15px;
    border-radius: 4px;
    overflow: hidden;
    flex-shrink: 0;
  }
  .van-tab {
    font-size: 16px;
  }
}
</style>
